var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSadFace = function SvgSadFace(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 388,
    height: 339,
    viewBox: "0 0 388 339"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#414756",
    strokeWidth: 3,
    d: "M194 306c27.406 0 57.852 0 86.278-5.289 7.925-1.474 59.483 38.597 66.984 36.186 8.215-2.64-27.68-47.867-20.249-51.92C363.015 265.35 388.135 227.395 386 154 381.579 2 277.947 2 194 2S2 2 2 154s108.053 152 192 152z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DBE1E7",
    d: "M198 297c78.977 0 173 0 173-143S276.977 11 198 11 25 11 25 154s94.023 143 173 143z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(109 121)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#414756"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154,
    cy: 15,
    r: 15,
    fill: "#414756"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#414756",
    strokeLinecap: "round",
    strokeWidth: 4,
    d: "M133 98c0-38.185-20.708-54-45-54S43 58.435 43 98"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#414756",
    strokeLinecap: "round",
    strokeWidth: 3,
    d: "M353.1 100.09c-6.871-29.76-26.276-53.31-51.2-66.18M39.526 201.379c6.288 32.348 26.416 58.454 52.948 73.242"
  }))));
};
export { SvgSadFace as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzODgiIGhlaWdodD0iMzM5IiB2aWV3Qm94PSIwIDAgMzg4IDMzOSI+CiAgICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxnPgogICAgICAgICAgICA8Zz4KICAgICAgICAgICAgICAgIDxwYXRoIGZpbGw9IiNGRkYiIHN0cm9rZT0iIzQxNDc1NiIgc3Ryb2tlLXdpZHRoPSIzIiBkPSJNMTkyIDMwNGMyNy40MDYgMCA1Ny44NTIgMCA4Ni4yNzgtNS4yODkgNy45MjUtMS40NzQgNTkuNDgzIDM4LjU5NyA2Ni45ODQgMzYuMTg2IDguMjE1LTIuNjQtMjcuNjgtNDcuODY3LTIwLjI0OS01MS45MkMzNjEuMDE1IDI2My4zNSAzODYuMTM1IDIyNS4zOTUgMzg0IDE1MiAzNzkuNTc5IDAgMjc1Ljk0NyAwIDE5MiAwUzAgMCAwIDE1MnMxMDguMDUzIDE1MiAxOTIgMTUyeiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTYwMiAtMzcwKSB0cmFuc2xhdGUoNjA0IDM3MikiLz4KICAgICAgICAgICAgICAgIDxwYXRoIGZpbGw9IiNEQkUxRTciIGQ9Ik0xOTYgMjk1Yzc4Ljk3NyAwIDE3MyAwIDE3My0xNDNTMjc0Ljk3NyA5IDE5NiA5IDIzIDkgMjMgMTUyczk0LjAyMyAxNDMgMTczIDE0M3oiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC02MDIgLTM3MCkgdHJhbnNsYXRlKDYwNCAzNzIpIi8+CiAgICAgICAgICAgICAgICA8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNjAyIC0zNzApIHRyYW5zbGF0ZSg2MDQgMzcyKSB0cmFuc2xhdGUoMTA3IDExOSkiPgogICAgICAgICAgICAgICAgICAgIDxjaXJjbGUgY3g9IjE1IiBjeT0iMTUiIHI9IjE1IiBmaWxsPSIjNDE0NzU2Ii8+CiAgICAgICAgICAgICAgICAgICAgPGNpcmNsZSBjeD0iMTU0IiBjeT0iMTUiIHI9IjE1IiBmaWxsPSIjNDE0NzU2Ii8+CiAgICAgICAgICAgICAgICAgICAgPHBhdGggc3Ryb2tlPSIjNDE0NzU2IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS13aWR0aD0iNCIgZD0iTTEzMyA5OGMwLTM4LjE4NS0yMC43MDgtNTQtNDUtNTRTNDMgNTguNDM1IDQzIDk4Ii8+CiAgICAgICAgICAgICAgICA8L2c+CiAgICAgICAgICAgICAgICA8cGF0aCBzdHJva2U9IiM0MTQ3NTYiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLXdpZHRoPSIzIiBkPSJNMzUxLjEgOTguMDljLTYuODcxLTI5Ljc2LTI2LjI3Ni01My4zMS01MS4yLTY2LjE4TTM3LjUyNiAxOTkuMzc5YzYuMjg4IDMyLjM0OCAyNi40MTYgNTguNDU0IDUyLjk0OCA3My4yNDIiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC02MDIgLTM3MCkgdHJhbnNsYXRlKDYwNCAzNzIpIi8+CiAgICAgICAgICAgIDwvZz4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPgo=";